export default "__VITE_ASSET__XjpdYUJI__"